<template>
  <div
    data-component-group="threads-form"
    data-component="deal-url"
    :class="getComponentClass()"
  >
    <slot name="beforeForm" />

    <v-text-field
      v-model="publishedUrl"
      label="Deal URL"
      :readonly="isDisabled"
      :loading="isLoading"
      type="text"
      class="deal-url"
      :error-messages="urlErrors"
      @blur="v$.publishedUrl.$touch()"
      @click="viewUrlFromInput"
    />

    <div v-if="!isDisabled" class="component-actions">
      <v-btn color="secondary" :loading="isLoading" @click="submit">
        <v-icon>edit</v-icon>
        {{ triggerLabel }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core'
  import { required, url } from '@vuelidate/validators';
  import { isObj, openUrlInNewWindow } from '../../../utils';

  // TODO: Translate component

  export default {
    setup () {
    return {
      v$: useVuelidate()
    }
  },
    validations() {
      return {
        publishedUrl: {
          url,
          required,
        },
      };
    },
    props: {
      thread: {
        type: Object,
        default: undefined,
      },
      triggerLabel: {
        type: String,
        default: 'Save & Publish',
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
      onSubmit: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        publishedUrl: '',
      };
    },
    computed: {
      merchantName() {
        return isObj(this.merchant) ? this.merchant.name : '';
      },
      urlErrors() {
        return this.v$.publishedUrl.$errors.map(error => {
          if (error.$validator === 'required') {
            return 'URL is required';
          }
          if (error.$validator === 'url') {
            return 'Must be valid URL';
          }
          return error.$message;
        });
      },
      canSubmitRequest() {
        return this.publishedUrl !== '';
      },
    },
    watch: {
      thread(nextThread) {
        if (isObj(nextThread)) {
          this.v$.$reset();
          this.publishedUrl = nextThread.published_url;
        }
      },
    },
    created() {
      if (isObj(this.thread)) {
        this.publishedUrl = this.thread.published_url;
      }
    },
    methods: {
      submit() {
        this.v$.$touch();

        if (!this.canSubmitRequest || this.v$.$error) {
          return false;
        }

        this.onUpdateUrl();
      },
      onUpdateUrl() {
        const { publishedUrl, onSubmit } = this;
        onSubmit(publishedUrl);
      },
      viewUrlFromInput() {
        if (this.isDisabled && this.canSubmitRequest) {
          openUrlInNewWindow(window.open(), this.publishedUrl);
        }
      },
      getComponentClass() {
        return {
          'is-disabled': this.isDisabled,
        };
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='threads-form'][data-component='deal-url'] {
  padding: $spacing-xl;
  background-color: rgb(var(--v-theme-surface));
  border-top: 1px solid map.get($colors, grey, lighten-2);

  &.is-disabled {
    .deal-url {
      cursor: pointer !important;

      input {
        cursor: pointer !important;
      }
    }
  }

  .component-actions {
    text-align: right;

    .v-btn {
      margin: 0;

      .v-icon {
        margin: 0 6px 0 0;
      }
    }
  }
}
</style>
